import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';

import pushEvent, { SHOW_FAQ } from 'pushEvent/index';

import style from './SharedZoneNewFaq.module.pcss';
import { SharedZoneNewQuestion } from '../SharedZoneNewQuestion';

const cx = classNames.bind(style);

const SharedZoneNewQuestions = ({ faq }) => {
  const [activeIndexes, setActiveIndexes] = useState({});

  const { mainTitle, questions } = faq;

  const toggleActiveQuestion = (index) =>
    setActiveIndexes((prevActiveIndexes) => {
      if (!prevActiveIndexes[index]) {
        const selectedQuestion = questions[index];
        pushEvent(SHOW_FAQ, { title: selectedQuestion.title });
      }

      return {
        ...prevActiveIndexes,
        [index]: !prevActiveIndexes[index],
      };
    });

  return (
    <div className={cx('wrap')}>
      {!!mainTitle && (
        <div className={cx('title')}>
          <Text size="size2-m">{mainTitle}</Text>
        </div>
      )}
      {!!questions.length && (
        <ul className={cx('questions')}>
          {questions.map(({ slug, title, description }, index) => (
            <SharedZoneNewQuestion
              key={`${slug}_${index}`}
              isActive={activeIndexes[index]}
              title={title}
              description={description}
              onClick={() => toggleActiveQuestion(index)}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default SharedZoneNewQuestions;
